import { toast } from 'react-toastify';

import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';

import {
  toggleDrawer,
  changeDrawer,
  clearDrawer,
  modifyTitle,
  requestSuccess,
} from './actions';

export function toggle() {
  put(toggleDrawer());
}

export function changed({ payload }) {
  const { key, value } = payload;
  put(changeDrawer(key, value));
}

export function cleaningUp() {
  put(clearDrawer());
}

export function modifyTitleNavbar({ payload }) {
  const { title } = payload;
  put(modifyTitle(title));
}

export function* navigation() {
  try {
    const { data } = yield call(api.get, 'menussistema');

    yield put(requestSuccess(data));
  } catch (erros) {
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@drawer/TOGGLE', toggle),
  takeLatest('@drawer/CHANGING', changed),
  takeLatest('@drawer/CLEANING_UP', cleaningUp),
  takeLatest('@drawer/MODIFY_TITLE', modifyTitleNavbar),
  takeLatest('@drawer/REQUEST_NAVIGATION', navigation),
]);
